import React from "react";

const ServiceImageSlots = ({
  imageSlots,
  onChangeSlot,
  onRemoveSlot,
  maxImages = 4,
  inputPrefix = "service-image-slot",
  disabled = false,
}) => {
  return (
    <div className="rounded-2xl border border-[var(--accent-primary)] bg-[var(--accent-primary-soft)] p-4">
      <label className="block text-[var(--accent-primary)] font-medium mb-2">Photos du service</label>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-3">
        {imageSlots.map((slot, idx) => {
          const slotPreview = slot.newPreviewUrl || slot.existingUrl;
          const inputId = `${inputPrefix}-${idx}`;

          return (
            <div key={inputId} className="border border-gray-200 rounded-lg p-2 bg-gray-50">
              <div className="relative w-full h-24 rounded-md overflow-hidden bg-gray-200 flex items-center justify-center mb-2">
                {slotPreview ? (
                  <img
                    src={slotPreview}
                    alt={`Slide ${idx + 1}`}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.target.src = "/default-service.png";
                    }}
                  />
                ) : (
                  <span className="text-xs text-gray-500 text-center px-2">Emplacement vide</span>
                )}

                {slotPreview && (
                  <button
                    type="button"
                    onClick={() => onRemoveSlot(idx)}
                    className={`absolute top-1 right-1 rounded-full w-5 h-5 text-xs flex items-center justify-center ${
                      disabled
                        ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                        : "bg-red-500 text-white"
                    }`}
                    aria-label={`Supprimer l'image du slot ${idx + 1}`}
                    disabled={disabled}
                  >
                    ✕
                  </button>
                )}
              </div>

              <input
                id={inputId}
                type="file"
                accept="image/*"
                onChange={(e) => onChangeSlot(idx, e)}
                className="hidden"
                disabled={disabled}
              />

              <label
                htmlFor={inputId}
                className={`block text-center text-xs border border-gray-300 rounded-md py-1 px-2 ${
                  disabled
                    ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                    : "bg-white hover:bg-gray-100 cursor-pointer"
                }`}
              >
                Sélectionner une photo
              </label>

              <p className="text-[10px] text-gray-500 text-center mt-1">
                Slot {idx + 1} {slot.newFile ? "(nouvelle)" : slot.existingUrl ? "(actuelle)" : ""}
              </p>
            </div>
          );
        })}
      </div>

      <p className="text-xs text-gray-400 mt-1">
        Max {maxImages} images. Cliquez sur la case voulue puis sur Sélectionner une photo pour ajouter ou remplacer.
      </p>
    </div>
  );
};

export default ServiceImageSlots;
